import Icon from '../components/Icon.vue'

Icon.register({
  'user-graduate': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M319.4 320.6L224 416 128.6 320.6C57.1 323.7 0 382.2 0 454.4V464C0 490.5 21.5 512 48 512H400C426.5 512 448 490.5 448 464V454.4C448 382.2 390.9 323.7 319.4 320.6zM13.6 79.8L20 81.3V139.7C13 143.9 8 151.2 8 160 8 168.4 12.6 175.4 19.1 179.7L3.5 242C1.8 248.9 5.6 256 11.1 256H52.9C58.4 256 62.2 248.9 60.5 242L44.9 179.7C51.4 175.4 56 168.4 56 160 56 151.2 51 143.9 44 139.7V87.1L110 103C101.4 120.2 96 139.4 96 160 96 230.7 153.3 288 224 288S352 230.7 352 160C352 139.4 346.7 120.2 338 103L434.3 79.8C452.5 75.4 452.5 52.7 434.3 48.3L243.9 2.3C230.9-0.8 217.2-0.8 204.2 2.3L13.6 48.2C-4.5 52.6-4.5 75.4 13.6 79.8z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/user-graduate.js
// module id = hMfk
// module chunks = 144